import { Injectable, inject } from '@angular/core';
import { IS_MOBILE, runWhenIdle } from '@lite-workspace/utils';
// /config entry, not the barrel: the barrel drags opentype.js into the main bundle.
import { PsdRenderWasmService } from '@lite-workspace/shared/psd-render-wasm/config';

/** Downloads the album editor (both route chunks) and the render wasm ahead of the click into it. */
@Injectable({ providedIn: 'root' })
export class EditorWarmup {
  private readonly isMobile = inject(IS_MOBILE);
  private readonly psdRender = inject(PsdRenderWasmService);

  /** Specifiers must match app.routes.ts and album-editor.routes.ts, or esbuild emits a second chunk nobody clicks into. */
  warm(): void {
    void import('@lite-workspace/album-editor').catch(() => undefined);
    void import('./album-editor.routes').catch(() => undefined);
    this.psdRender.preload();
  }

  /** Desktop only: a phone would download the whole editor it may never open. Returns the cancel. */
  whenIdle(): () => void {
    return this.isMobile() ? () => undefined : runWhenIdle(() => this.warm());
  }
}
